<script setup lang="ts">
import { useRoute } from 'vue-router'

const route = useRoute()

const navItems = [
  { name: 'Dashboard', path: '/', icon: '🏠' },
  { name: 'Daily Docs', path: '/daily', icon: '📅' },
  { name: 'Reference', path: '/reference', icon: '📚' },
  { name: 'SQL Library', path: '/sql', icon: '💾' },
  { name: 'Search', path: '/search', icon: '🔍' }
]

function isActive(path: string): boolean {
  if (path === '/') {
    return route.path === '/'
  }
  return route.path.startsWith(path)
}
</script>

<template>
  <aside
    class="w-64 bg-white border-r border-gray-200 flex flex-col"
    aria-label="Main navigation"
  >
    <!-- Logo -->
    <div class="p-6 border-b border-gray-200">
      <h1 class="text-2xl font-bold text-gray-900">
        HQ Dashboard
      </h1>
      <p class="text-sm text-gray-600 mt-1">
        Mission Control
      </p>
    </div>

    <!-- Navigation -->
    <nav
      class="flex-1 p-4"
      aria-label="Primary"
    >
      <ul
        class="space-y-2"
        role="list"
      >
        <li
          v-for="item in navItems"
          :key="item.path"
        >
          <RouterLink
            :to="item.path"
            :aria-current="isActive(item.path) ? 'page' : undefined"
            :class="[
              'flex items-center gap-3 px-4 py-3 rounded-lg transition-colors',
              isActive(item.path) ? 'bg-primary text-white' : 'text-gray-700 hover:bg-gray-100'
            ]"
          >
            <span
              class="text-xl"
              aria-hidden="true"
            >{{ item.icon }}</span>
            <span class="font-medium">{{ item.name }}</span>
          </RouterLink>
        </li>
      </ul>
    </nav>

    <!-- Footer -->
    <div class="p-4 border-t border-gray-200">
      <p class="text-xs text-gray-500 text-center">
        Phase 1: Static Site<br>
        Built with Vue 3 + Vite
      </p>
    </div>
  </aside>
</template>
